import { Box, Button, CloseButton, Flex, Heading, IconButton, Text } from '@chakra-ui/react'
import { useRouter } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'

import useColorModeValue from '@/hooks/useColorModeValue'

import { IFeatureCardProps } from '../types/feature'

const NewsCard: React.FC<IFeatureCardProps> = ({ heading, description, link, onClose }) => {
    const headingColor = useColorModeValue('var(--chakra-colors-orange-400)', 'var(--chakra-colors-white)')
    const bgColor = useColorModeValue('var(--chakra-colors-yellow-25)', 'var(--chakra-colors-dark-100)')
    const subHeadingColor = useColorModeValue('var(--chakra-colors-gray-600)', 'var(--chakra-colors-white)')
    const router = useRouter()
    const { t } = useTranslation()
    const handleCardClick = () => {
        router.navigate({ to: link })
    }

    const handleCloseClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        onClose?.()
    }

    return (
        <Box
            borderWidth="1px"
            borderRadius="xl"
            overflow="hidden"
            boxShadow="md"
            p={4}
            _hover={{ boxShadow: 'xl', cursor: 'pointer' }}
            position="relative"
            bg={bgColor}
        >
            <IconButton aria-label="Close" size="sm" position="absolute" top={2} right={2} onClick={handleCloseClick} variant="ghost">
                <CloseButton />
            </IconButton>
            <Flex align="center" justify="space-between">
                <Box flex="1">
                    <Text as="h5" color={headingColor} fontWeight="bold" fontSize="sm" mb={1} letterSpacing="1.5px">
                        {t('news.newFeature.title')}
                    </Text>
                    <Heading as="h3" size="md" mb={2} letterSpacing="0.25px">
                        {heading}
                    </Heading>
                    <Text as="h2" fontSize="sm" color={subHeadingColor} mb={2} letterSpacing="0.25px">
                        {description}
                    </Text>
                    <Button
                        aria-label="ReadMore"
                        color={subHeadingColor}
                        size="2xs"
                        onClick={handleCardClick}
                        variant="outline"
                        rounded="2xl"
                        letterSpacing="0.25px"
                    >
                        {t('news.newFeature.readMore')}
                    </Button>
                </Box>
            </Flex>
        </Box>
    )
}

export default NewsCard
